interface RouteMatchInterface {
  cvt2Regex: (route: string) => string;
  match: (route: string, matches: string[]) => boolean;
}

export const RouteMatch: RouteMatchInterface = {
  cvt2Regex: (route: string) => {
    const routeParts = route
      .split("/")
      .map((part) =>
        part
          .replace("$any", "?[\\w\\/-]+")
          .replace("$number", "[\\d]+")
          .replace("$text", "[\\w-]+"),
      );
    return `^${routeParts.join("\\/")}$`;
  },
  match: (route: string, matches: string[]) => {
    const regexList = matches.map(
      (route) => new RegExp(RouteMatch.cvt2Regex(route)),
    );
    return regexList.some((regex) => regex.test(route));
  },
};
